__turbopack_context__.v({
  "currentPrice": "ZvXMOa_currentPrice",
  "unitPrice": "ZvXMOa_unitPrice",
  "wrapper": "ZvXMOa_wrapper",
});
